// Niveles de clasificación de seguridad, compartidos por el formulario
// común (NewItem) y la ficha de información. El id es el valor guardado.
export type ClassificationOption = { id: number; level: string };

export const levelOptions: ClassificationOption[] = [
  { id: 0, level: "Baja" },
  { id: 1, level: "Moderada/Media" },
  { id: 2, level: "Alta" },
];

export const confidOptions: ClassificationOption[] = [
  { id: 0, level: "Pública" },
  { id: 1, level: "Interna" },
  { id: 2, level: "Confidencial" },
  { id: 3, level: "Reservada" },
  { id: 4, level: "Secreta" },
];
